import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Metode de plată',
  fields: {
    hidden_payment_methods: {
      label: 'Metode de plată ascunse',
    },
    has_online_payments: {
      label: 'Acceptă plăți online',
    },
    has_paypal_upcharge: {
      label: 'Suprataxă de 3,5% pentru tranzacții PayPal',
    },
    has_cash_payments: {
      label: 'Acceptă plăți cash',
    },
    has_occ_cash_payments: {
      label: 'Plăți cash Call Center activate',
    },
    has_in_store_card_payments: {
      label: 'Acceptă plăți cu cardul în magazin',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Etichetați plățile cash drept „Factură"',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Card',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Debit SEPA',
    [PaymentMethods.CASH]: 'Numerar',
    [PaymentMethods.BACS_DEBIT]: 'Debit Bacs',
    [PaymentMethods.PAY_BY_BANK]: 'Plată prin bancă',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Ridicare',
    [ORDER_METHODS.delivery]: 'Livrare',
    [ORDER_METHODS.room_service]: 'Serviciu cameră/masă',
  },
  modals: {
    confirmation: {
      title: 'Ești sigur?',
      description:
        'Odată confirmat, plățile online vor fi <strong>{{onlineState}}</strong>, plățile cash vor fi <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'oprit',
    on: 'pornit',
  },
  buttons: {
    save: 'Salvează',
    configure_online_payments: 'Configurează plățile online',
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
